import { render, staticRenderFns } from "./medical.vue?vue&type=template&id=e798a352&scoped=true&"
import script from "./medical.vue?vue&type=script&lang=js&"
export * from "./medical.vue?vue&type=script&lang=js&"
import style0 from "./medical.vue?vue&type=style&index=0&id=e798a352&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e798a352",
  null
  
)

export default component.exports